<script lang="ts">
import Button1XP from '../../Button1XP/Button1XP.vue';
import Link, { type NodeLink } from './Link/Link.vue';

export type NodeBase = {
  children?: Nodes;
  nodeType:
    | '#text'
    | 'a'
    | 'b'
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'i'
    | 'li'
    | 'ol'
    | 'p'
    | 'span'
    | 'sub'
    | 'sup'
    | 'ul';
  style?: string;
  text?: string;
};

type Nodes = Array<NodeBase | NodeLink>;

type Props = {
  nodes: Nodes;
};

const nodeTypeMap = {
  a: Link,
};
</script>

<script setup lang="ts">
defineProps<Props>();
</script>

<template>
  <template v-for="(node, index) in nodes" :key="index">
    <template v-if="node.nodeType === '#text'">
      <span v-if="node.text" v-html="node.text" />
    </template>

    <component
      :is="nodeTypeMap[node.nodeType] ?? node.nodeType"
      v-else
      v-bind="nodeTypeMap[node.nodeType] ? node : undefined"
    >
      <Button1XP
        v-if="node.text && node.style === 'phone-footer'"
        class="phone-footer"
        size="m"
        start-icon="phone"
        :text="node.text"
        :url="`tel:${node.text}`"
        variant="linkStatic"
      />

      <span v-else-if="node.text" v-html="node.text" />
      <Nodes v-if="node.children" :nodes="node.children" />
    </component>
  </template>
</template>
